export const mockDashboardStats = {
  'stats': {
    'Cameras': {
      'danger': [
        '2 cameras not working',
      ],
      'positive': [
        'Camera Uptime: 99.1 for last 30 days', // 40*100% + 2*0/42 in 30 day time period
        '40 cameras working',
      ],
    },
    'Faces': {
      'danger': [
        'Allison Clark not seen in 2 days',
      ],
      'positive': [
        'Faces seen in the last hour: 37',
      ],
      'warning': [
        'Unrecognized faces: 3',
      ],
    },
    'Alerts': {
      'danger': [
        '5 unread alerts',
      ],
      'positive': [
        '7 Alerts Configured',
      ],
      'latestAlerts': [
        'After hours crowd in elevator car 3',
        'Person in Camera Room',
        'Person in Plaza 1 Seating 51st after hour',
      ],
    },
    'Viewer': {
      'danger': [
        'Plaza 2 Playground: Full',
      ],
      'positive': [
        'Laundry Room: Empty',
      ],
      'warning': [
        'Gym: 2/3 Ellipticals in use',
        'Gym: 1/4 Treadmills in use',
      ],
    },
  },
}
